import React, { useState } from "react";
import { Form, Image } from "react-bootstrap";
import "../../../Assets/css/myaccount.css";
import { Breadcrumbs, Link, Typography } from "@material-ui/core";
import TextField from "@mui/material/TextField";
import { Col, Container, Row } from "react-bootstrap";
import Button from "@mui/material/Button";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import { NavLink } from "react-router-dom";
import axios from "axios";
import {
  Address_details,
  base_url,
  media_details,
  postHeader,
  Email_detailsSecond,
} from "../../../Helpers/request";
import swal from "sweetalert";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";

const Contact = () => {
  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
  const [first_name, setFirst_name] = useState("");
  const [last_name, setLast_name] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [comment, setComment] = useState("");

  const formsubmit = (e) => {
    e.preventDefault();
    var data = {
      first_name,
      last_name,
      email,
      phone,
      comment,
    };
    axios
      .post(base_url + "/user/contact", data, {
        headers: postHeader,
      })
      .then((response) => {
        if (response.data.status == 1) {
          setFirst_name("");
          setLast_name("");
          setEmail("");
          setComment("");
          setPhone("");
          return swal(response.data.message, "", "success");
        } else {
          return swal(response.data.message, "", "error");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails.title}</title>
        <meta name="description" content={metaDetails.description}></meta>
        <meta name="keywords" content={metaDetails.keywords}></meta>
      </Helmet>
      <div className="rcs_myaccount_section">
        <Container>
          <Row>
            <Col className="rcs_breadcrumb mb-2">
              <Breadcrumbs aria-label="breadcrumb">
                <NavLink underline="hover" color="inherit" to="/">
                  Home
                </NavLink>
                <Typography color="text.primary">Contact Us</Typography>
              </Breadcrumbs>
            </Col>
          </Row>
        </Container>
        <div className="rcs_appointment mt-5">
          <Container>
            <Row className="w-100 m-auto">
              <Col className="p-md-0 mb-5">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2482.672709600287!2d-0.11034912337922508!3d51.51922027181599!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48761b4db86f1311%3A0x51932ef0ef7bb162!2sHeart%20of%20Diamond!5e0!3m2!1sen!2sin!4v1702372837084!5m2!1sen!2sin"                  width="100%"
                  height="450"
                  style={{ border: "0" }}
                  allowfullscreen=""
                  loading="lazy"
                ></iframe>
              </Col>
            </Row>
            <Row className="w-100 m-auto">
              <Col sm={12} md={6} className="p-md-0">
                <Form onSubmit={formsubmit}>
                  <Row>
                    <Col xs={12} sm={6}>
                      <TextField
                        id="outlined-basic"
                        label="First Name"
                        type="text"
                        variant="outlined"
                        value={first_name}
                        onChange={(e) => setFirst_name(e.target.value)}
                        required
                      />
                    </Col>
                    <Col xs={12} sm={6}>
                      <TextField
                        id="outlined-basic"
                        label="Last Name"
                        type="text"
                        variant="outlined"
                        value={last_name}
                        onChange={(e) => setLast_name(e.target.value)}
                        required
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} sm={6}>
                      <TextField
                        id="outlined-basic"
                        label="Email Address"
                        type="Email"
                        variant="outlined"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </Col>
                    <Col xs={12} sm={6}>
                      <TextField
                        id="outlined-basic"
                        label="Phone"
                        type="number"
                        variant="outlined"
                        InputProps={{ inputProps: { min: 0 } }}
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        required
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <TextField
                        id="filled-multiline-static"
                        label="Your Message"
                        multiline
                        rows={4}
                        variant="outlined"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Button
                        variant="contained"
                        type="submit"
                        className="rcs_acc_button"
                      >
                        {" "}
                        <MailOutlineIcon className="mr-2" /> Send Message{" "}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Col>
              <Col sm={12} md={6}>
                <div className="rcs_contact_content">
                  <h1>Contact Us</h1>
                  <p>
                    Please send us a message, and our staff will be happy to
                    help you with any questions you have.
                  </p>
                  <ul className="rcs_content_address">
                    <li>
                      <h5>STORE ADDRESS</h5>
                      <address class="mb-0">
                        <li
                         className="hd_email"
                          onClick={() => {
                            window.open(Address_details.link, "_blank");
                          }}
                        >
                          {Address_details.textLine1}
                          <br />
                          {Address_details.textLine2}
                        </li>
                      </address>
                    </li>
                    <li>
                      <h5>STORE HOURS</h5>
                      <strong>Monday - Saturday:</strong> 10.30am -5.30pm
                      <br />
                      <strong>Sunday:</strong> 10.30am - 4pm
                      <br />
                    </li>
                  </ul>
                  <h4 className="mt-0">Email US</h4>
                  <ul className="rcs_content_social mb-4">
                    <li
                      className="hd_email"
                      onClick={() => {
                        window.open(Email_detailsSecond.link, "_blank");
                      }}
                    >
                      {Email_detailsSecond.text}
                    </li>
                  </ul>
                  <h4>FOLLOW US</h4>
                  <ul className="rcs_content_social">
                    {media_details.map((media, id) => (
                      <li key={id}>
                        <NavLink
                          onClick={() =>
                            window.open(`${media.account_link}`, "_blank")
                          }
                          to="#"
                        >
                          <Image
                            src={media.account_img}
                            alt={media.account_alt}
                          ></Image>
                        </NavLink>
                      </li>
                    ))}
                   </ul>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};

export default Contact;
